import { combineReducers, createStore } from 'redux'
import { AuthReducer } from './reducers/auth'
import { CampaignReducer } from "./reducers/campaigns"
import { SnackbarReducer } from "./reducers/snackbar"
import { PromotionReducer } from "./reducers/promotion";
import { SettingsCampaignsReducer } from "./reducers/settings/campaigns";
import { CompaniesReducer } from "./reducers/companies"
import { UsersReducer } from "./reducers/users"
import { ImagesReducer } from "./reducers/images"
import { TopicsReducer } from "./reducers/topics";
import { OverlayReducer } from "./reducers/overlay";
import { CategoriesReducer } from './reducers/categories';

const reducers = combineReducers({
	auth: AuthReducer,
	campaigns: CampaignReducer,
	snackbar: SnackbarReducer,
	promotion: PromotionReducer,
	campaignSettings: SettingsCampaignsReducer,
	companies: CompaniesReducer,
	users: UsersReducer,
	images: ImagesReducer,
	topics: TopicsReducer,
	overlay: OverlayReducer,
	categories: CategoriesReducer
});

export const store = createStore(
	reducers,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);


// WEBPACK FOOTER //
// ./src/reducers.js